import React, { useState } from 'react';
import iconSearch from '../../images/icon-search.svg';

const SearchField = ({ handleSearch, activeTab, placeholder }) => {
  const [searchValue, setSearchValue] = useState('');

  const onSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    handleSearch(value, activeTab);
  };

  return (
    <div className="form-nutrition-meals">
      <div className="position-relative wrap-meal-search mb-3">
        <input 
          type="text" 
          id="searchField"
          placeholder={placeholder} 
          className="form-control form-control-lg" 
          value={searchValue} 
          onChange={onSearchChange} // Trigger onChange when typing
        />
        <button className="btn-meal-search" style={{display:'none'}}>
          <img src={iconSearch} alt="Search" />
        </button>
      </div>
    </div>
  );
};

export default SearchField;